class SaveSetItem extends HTMLElement {
  constructor() {
    super();

    this.button = this.closest("button");
    this.form = this.button?.form;

    if (!this.form) return;

    this.onSubmit = (e) => {
      e.preventDefault();
      const formData = new FormData(this.form);

      const allowedKeys = ["id", "quantity"];
      const data = {};

      // Add each name/value pair to the object
      for (const [name, value] of formData) {
        const property = /properties\[(?<propertyKey>.+)\]/gm.exec(name);

        if (property || allowedKeys.includes(name)) {
          if (!property) {
            data[name] = value;
          } else {
            if (!("properties" in data)) {
              data.properties = {};
            }
            data.properties[property.groups.propertyKey] = value;
          }
        }
      }

      if (!("quantity" in data)) {
        data.quantity = 1;
      }

      data.quantity = parseInt(data.quantity);
      const setItemId =
        this.closest("[data-custom-data]")?.dataset.customData || null;

      this.dispatchEvent(
        new CustomEvent("save-set-item", {
          bubbles: true,
          detail: { data, setItemId },
        }),
      );

      document.dispatchEvent(new CustomEvent("markup-modal:close"));
    };

    this.form.addEventListener("submit", this.onSubmit);
  }

  disconnectedCallback() {
    this.form?.removeEventListener("submit", this.onSubmit);
  }
}

if (!customElements.get("save-set-item")) {
  customElements.define("save-set-item", SaveSetItem);
}
